import axios, { RawAxiosRequestConfig } from 'axios'
import Cookies from 'universal-cookie'

const cookies = new Cookies()
const unInterceptedAxios = axios.create()
const baseURL = process.env.REACT_APP_API_BASE_URL
const baseURLActivity = process.env.REACT_APP_MICROSERVICE_API_ENDPOINT

// Create axios instance with automatic token injection
const axiosInstance = axios.create()

axiosInstance.interceptors.request.use((config) => {
    const user = cookies.get('_cuser')
    if (config.headers && user?.accessToken) {
        config.headers.Authorization = `Bearer ${user.accessToken}`
    }
    return config
})

// Add response interceptor for token refresh
axiosInstance.interceptors.response.use((response) => response, async (error) => {
    const original = error.config
    if (error?.response?.data?.statusCode === 401 && original.url !== '/auth/login') {
        const user = cookies.get('_cuser')
        if (user?.refreshToken) {
            try {
                const refreshResponse = await unInterceptedAxios.post(`${baseURL}/auth/refresh`, {}, {
                    headers: {
                        Authorization: `Bearer ${user.refreshToken}`
                    }
                })
                
                const newUserData = {
                    ...user,
                    accessToken: refreshResponse.data.accessToken,
                    refreshToken: refreshResponse.data.refreshToken
                }
                cookies.set('_cuser', newUserData, { path: '/' })
                
                // Retry the original request with new token
                original.headers.Authorization = `Bearer ${refreshResponse.data.accessToken}`
                return axiosInstance.request(original)
            } catch (refreshError) {
                // Refresh failed, clear cookies and redirect to login
                cookies.remove('_cuser', { path: '/' })
                window.location.href = '/login'
                return Promise.reject(refreshError)
            }
        }
    }
    return Promise.reject(error)
})

export const HttpRequest = (requestConfig: RawAxiosRequestConfig) => {
    return axiosInstance.request({ baseURL, ...requestConfig})
}
export const HttpBaseRequest = (requestConfig: RawAxiosRequestConfig) => {
    return unInterceptedAxios.request({ baseURL, ...requestConfig})
}

export const HttpRequestActivity = (requestConfig: RawAxiosRequestConfig) => {
    return axiosInstance.request({ baseURL: baseURLActivity, ...requestConfig})
}
